import { z } from 'zod';
export const organizationDetailSearchSchema = z.object({
  baseDate: z.string().optional(),
  positionId: z.string().optional(),
  positionName: z.string().optional(),
  jobTypeId: z.string().optional(),
  jobTypeName: z.string().optional(),
  employmentTypeId: z.string().optional(),
  employmentTypeName: z.string().optional(),
  search: z.string().optional()
});
export type OrganizationSearchParams = z.infer<typeof organizationDetailSearchSchema>;